export default __webpack_public_path__ + "static/media/oxo_cow_logo.2945e5ae.svg";